import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="23" viewBox="0 0 19 23">
    <path fill="#1D1D1B" fillRule="evenodd" d="M.607.448h4.354V18.32h13.053v3.928H.607z" />
  </svg>
);
